import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';

const RequireRole = ({ children, permissions = [] }) => {
    const { user } = useAuth();
    const location = useLocation();
    const toastShownRef = useRef(false);

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check if user has all required permissions
    const hasRequiredPermissions = permissions.length === 0 ||
        permissions.every(permission => {
            // Handle both string and object permissions
            const permissionName = typeof permission === 'object' ? permission.name : permission;

            // Split the permission into action and module (e.g., 'view_equipment_details' -> ['view', 'equipment_details'])
            const [action, ...moduleParts] = permissionName.split('_');
            const module = moduleParts.join('_');

            // Check if the user has the required permission in their role's permissions
            return user.role?.permissions?.[module]?.[action] === true;
        });

    if (!hasRequiredPermissions) {
        if (!toastShownRef.current) {
            toastShownRef.current = true;
            toast.error("You don't have permission to view this page.", {
                toastId: `access-denied-${location.pathname}`,
            });
        }
        return <Navigate to="/dashboard" state={{ from: location }} replace />;
    }

    return children;
};

export default RequireRole; 